/* eslint-disable no-useless-constructor */
import React, { Component, createRef } from "react";

export default  class SectionLoading extends Component {
  constructor (props) {
    super(props)
    this.spinnerLoad = createRef()

  }
  componentDidUpdate() {
    if (!this.props.show) {
      this.spinnerLoad.current.classList.add('is-hidden')
    } else {
      this.spinnerLoad.current.classList.remove('is-hidden')
    }
  }
  render() {
        return (
            <>
            
            <div ref={ this.spinnerLoad } className="ld ld-spinner  ld-spin">
            </div>
            { !this.props.show && this.props.children }

            </>
        )
  }
}